// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__34Zof","tab_lis":"Tab_tab_lis__EEai4","tab_txt":"Tab_tab_txt___po2O","active":"Tab_active__g_sWE"};